/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_YieldInputs */

const en_editor_yield = /** @type {(inputs: Editor_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makes`)
};

const de_editor_yield = /** @type {(inputs: Editor_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergibt`)
};

/**
* | output |
* | --- |
* | "Makes" |
*
* @param {Editor_YieldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_yield = /** @type {((inputs?: Editor_YieldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_YieldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_yield(inputs)
	return en_editor_yield(inputs)
});